import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Ciclo } from '@app/shared/models/ciclo';
import { FiltroResultadoAvaliacao } from '../models/filtro-resultado-avaliacao';
import { Observable } from 'rxjs';
import { Orgao } from '@app/shared/models/orgao';
import { ProcessoAvaliativo } from '@app/shared/models/processo-avaliativo';
import { ResultadoAvaliacaoPaginado } from '../models/resultado-avaliacao';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ResultadoAvaliacaoApiService {
	private readonly http = inject(HttpClient);

	listarOrgaos(): Observable<Orgao[]> {
		return this.http.get<Orgao[]>(`${environment.RESULTADO_AVALIACAO_INSTITUCIONAL}/orgaos`);
	}

	listarProcessosAvaliativos(idOrgao: number): Observable<ProcessoAvaliativo[]> {
		return this.http.get<ProcessoAvaliativo[]>(
			`${environment.RESULTADO_AVALIACAO_INSTITUCIONAL}/processos-avaliativos/idOrgao/${idOrgao}`
		);
	}

	listarCiclos(idOrgao: number, idProcessoAvaliatico: number): Observable<Ciclo[]> {
		return this.http.get<Ciclo[]>(
			`${environment.RESULTADO_AVALIACAO_INSTITUCIONAL}/ciclos/id-orgao/${idOrgao}/id-processoAvaliativo/${idProcessoAvaliatico}`
		);
	}

	consultarResultadoAvaliacaoInstitucional(filtro: FiltroResultadoAvaliacao): Observable<ResultadoAvaliacaoPaginado> {
		let params = new HttpParams();
		params = params.set('idOrgao', filtro.idOrgao!.toString());
		if (filtro.idProcessoAvaliativo) {
			params = params.set('idProcessoAvaliativo', filtro.idProcessoAvaliativo.toString());
		}
		if (filtro.idCiclo) {
			params = params.set('idCiclo', filtro.idCiclo.toString());
		}
		if (filtro.page != null) {
			params = params.append('page', filtro.page);
		}
		if (filtro.size != null) {
			params = params.append('size', filtro.size);
		}
		if (filtro.sort != null) {
			params = params.append('sort', filtro.sort);
		}
		return this.http.get<ResultadoAvaliacaoPaginado>(`${environment.RESULTADO_AVALIACAO_INSTITUCIONAL}/consultar-alcance`, {
			params: params
		});
	}

	salvarAlcance(alcance: number, idAvaliacao: number): Observable<any> {
		const httpOptions = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' })
		};
		return this.http.put<any>(
			`${environment.RESULTADO_AVALIACAO_INSTITUCIONAL}/salvar-alcance/idAvaliacaoInstitucional/${idAvaliacao}`,
			alcance,
			httpOptions
		);
	}
}
